/**
 * Context for overriding user role level in debug mode
 * Allows testing different user levels without changing database roles
 */

import { createContext, useContext, useState, ReactNode } from "react";

interface DebugUserLevelContextType {
  /**
   * Override user level (2, 4, 5, 6, or 8)
   * null means use actual user level from database
   */
  overrideLevel: number | null;
  /**
   * Set the override level
   */
  setOverrideLevel: (level: number | null) => void;
}

export const DebugUserLevelContext = createContext<DebugUserLevelContextType | undefined>(undefined);

/**
 * Provider component for debug user level context
 */
export const DebugUserLevelProvider = ({ children }: { children: ReactNode }) => {
  const [overrideLevel, setOverrideLevel] = useState<number | null>(null);

  return (
    <DebugUserLevelContext.Provider value={{ overrideLevel, setOverrideLevel }}>
      {children}
    </DebugUserLevelContext.Provider>
  );
};

/**
 * Hook to access debug user level context
 */
export const useDebugUserLevel = () => {
  const context = useContext(DebugUserLevelContext);
  if (context === undefined) {
    throw new Error("useDebugUserLevel must be used within a DebugUserLevelProvider");
  }
  return context;
};









